export default __webpack_public_path__ + "static/media/5.25.c188dac6.mp3";